var map = {
	"./广告-5 - 一代枭雄.jpg": "ea89",
	"./广告-5 - 巧借东风.jpg": "8e2c",
	"./广告-5 - 得陇望蜀.jpg": "c964",
	"./广告-5 - 抚琴退敌.jpg": "a823",
	"./广告-5 - 暗渡陈仓.jpg": "8dd6",
	"./广告-5 - 杜康解忧.jpg": "2a25",
	"./广告-5 - 桃园结义.jpg": "48c1",
	"./广告-5 - 牛刀小试.jpg": "4647",
	"./广告-5 - 群雄逐鹿.jpg": "9112e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "057b";